import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { INDUSTRIES } from "@/data/content";
import { MaskLines } from "@/components/site/Reveal";

export const IndustryCard = ({ ind, i, detailed = false }) => (
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.12 }}
    transition={{ duration: 0.8, delay: (i % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
    data-testid={`industry-card-${ind.id}`}
    className="group relative flex h-full flex-col overflow-hidden rounded-3xl border border-slate-200 bg-white p-8 transition-[transform,border-color,box-shadow] duration-500 hover:-translate-y-1.5 hover:border-[#1777AF]/40 hover:shadow-[0_24px_60px_-30px_rgba(23,119,175,0.45)]"
  >
    <span className="absolute inset-x-0 top-0 h-1 origin-left scale-x-0 bg-gradient-to-r from-[#1777AF] to-[#29C1D3] transition-transform duration-700 group-hover:scale-x-100" />
    <div className="flex items-center justify-between">
      <span className="grid h-12 w-12 place-items-center rounded-2xl bg-[#0E2657] text-cyan-300 transition-transform duration-500 group-hover:-rotate-6">
        <ind.icon className="h-5 w-5" />
      </span>
      <span className="font-mono text-xs text-slate-400">0{i + 1}</span>
    </div>
    <h3 className="mt-8 font-display text-2xl font-semibold tracking-tight text-slate-900">{ind.title}</h3>
    <p className="mt-3 leading-relaxed text-slate-600">{ind.text}</p>
    {detailed && (
      <dl className="mt-6 space-y-4 border-t border-slate-100 pt-6 text-sm">
        <div><dt className="eyebrow text-slate-500">Challenge</dt><dd className="mt-1 text-slate-700">{ind.challenge}</dd></div>
        <div><dt className="eyebrow text-[#1777AF]">What we deliver</dt><dd className="mt-1 text-slate-700">{ind.deliver}</dd></div>
      </dl>
    )}
    <div className="mt-auto flex flex-wrap gap-2 pt-8">
      {ind.tags.map((t) => (
        <span key={t} className="rounded-full bg-[#EAF0F7] px-3 py-1 font-mono text-xs text-slate-600">{t}</span>
      ))}
    </div>
  </motion.div>
);

export const IndustriesGrid = () => (
  <section data-testid="industries-section" className="bg-[#EAF0F7] py-24 sm:py-32">
    <div className="container-x">
      <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
        <div>
          <p className="eyebrow text-[#1777AF]">Industries we serve</p>
          <MaskLines lines={["Built for the way", "your sector works."]} className="mt-5 font-display text-4xl font-bold leading-[1.02] tracking-tight text-slate-900 sm:text-5xl lg:text-6xl" />
        </div>
        <Link to="/industries" data-testid="industries-view-all" className="btn-ghost w-fit border-slate-300 text-slate-900 hover:border-[#1777AF] hover:text-[#1777AF]">
          All industries <ArrowUpRight className="h-4 w-4" />
        </Link>
      </div>
      <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {INDUSTRIES.map((ind, i) => <IndustryCard key={ind.id} ind={ind} i={i} />)}
      </div>
    </div>
  </section>
);
